import { render, staticRenderFns } from "./flavour-types.vue?vue&type=template&id=b3e91f1e"
import script from "./flavour-types.vue?vue&type=script&lang=js"
export * from "./flavour-types.vue?vue&type=script&lang=js"
import style0 from "./flavour-types.vue?vue&type=style&index=0&id=b3e91f1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports